import React from "react";

/**
 * Brand-dot divider — a small orange circle used as a graphical divider
 * between a heading and the text below it. Echoes the "Ur Designs." logo
 * dot. Sized as a subtle punctuation mark, not a visual heavy hitter.
 *
 * Rendered as a centered inline-block by default so it flows nicely
 * between stacked heading/description elements; the containing block
 * controls horizontal alignment.
 *
 * Props:
 *   size    "sm" | "md" (default "md") — 6px or 8px diameter
 *   testId  optional data-testid
 */
export const BrandDot = ({ size = "md", variant = "orange", testId, className = "" }) => {
  const px = size === "sm" ? "w-1.5 h-1.5" : "w-2 h-2";
  const color = variant === "dark" ? "bg-[#0F0F0F]" : "bg-[#FF6600]";
  return (
    <div className={`flex justify-center my-4 ${className}`} data-testid={testId || "brand-dot"}>
      <span className={`${px} rounded-full ${color}`} aria-hidden="true" />
    </div>
  );
};
